import {
  FETCH_JOBS_REQUEST,
  FETCH_JOBS_SUCCESS,
  FETCH_JOBS_FAILURE,
  ADD_JOB_REQUEST,
  ADD_JOB_SUCCESS,
  ADD_JOB_FAILURE,
  UPDATE_JOB_REQUEST,
  UPDATE_JOB_SUCCESS,
  UPDATE_JOB_FAILURE,
  DELETE_JOB_REQUEST,
  DELETE_JOB_SUCCESS,
  DELETE_JOB_FAILURE,
} from './actionType';

export const fetchJobsRequest = (payload) => ({
  type: FETCH_JOBS_REQUEST,
  payload,
});

export const fetchJobsSuccess = (jobs) => ({
  type: FETCH_JOBS_SUCCESS,
  payload: jobs,
});

export const fetchJobsFailure = (error) => ({
  type: FETCH_JOBS_FAILURE,
  payload: error,
});

export const addJobRequest = (payload) => ({
  type: ADD_JOB_REQUEST,
  payload,
});

export const addJobSuccess = (job) => ({
  type: ADD_JOB_SUCCESS,
  payload: job,
});

export const addJobFailure = (error) => ({
  type: ADD_JOB_FAILURE,
  payload: error,
});

export const updateJobRequest = (payload) => ({
  type: UPDATE_JOB_REQUEST,
  payload,
});

export const updateJobSuccess = (job) => ({
  type: UPDATE_JOB_SUCCESS,
  payload: job,
});

export const updateJobFailure = (error) => ({
  type: UPDATE_JOB_FAILURE,
  payload: error,
});

export const deleteJobRequest = (payload) => ({
  type: DELETE_JOB_REQUEST,
  payload,
});

export const deleteJobSuccess = (job) => ({
  type: DELETE_JOB_SUCCESS,
  payload: job,
});

export const deleteJobFailure = (error) => ({
  type: DELETE_JOB_FAILURE,
  payload: error,
});